angular.module('octopusApp.tenants')
    .directive('appliedTagsList', function() {
        return {
            restrict: 'E',
            replace: true,
            transclude: false,
            require: 'ngModel',
            scope: true,
            link: function($scope, $element, attr, ngModel) {
                ngModel.$render = function onRender() {
                    if(ngModel.$viewValue) {
                       $scope.vm.reloadTags(ngModel.$viewValue);
                    }
                };
            },
            controller: function(octopusTagSets) {
                var vm = this;
                vm.tags = [];
                vm.reloadTags = reloadTags;

                function reloadTags(model) {
                    if(_.all(model, function(a) { return a.hasOwnProperty("Color") && a.hasOwnProperty("Name"); })){
                        vm.tags = model;
                    } else {
                        octopusTagSets.getTag(model).then(function (tags) {
                            vm.tags = tags;
                        });
                    }
                }
            },
            controllerAs: 'vm',
            bindToController: true,
            template: '<div class="applied-tags-list">' +
            '   <div ng-repeat="tag in vm.tags">' +
            '       <i class="fa fa-square tag-swatch"  ng-style="{ \'color\' : tag.Color}" uib-tooltip="{{tag.Name}}" tooltip-placement="auto top"></i>' +
            '   </div>' +
            '</div>'
        };
    });


//////////////////
// WEBPACK FOOTER
// ./app/areas/tenants/advanced_tenant_selector/applied_tags_list.js
// module id = 4090849896351873
// module chunks = 1